import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { ICcnrObserver } from '@src/slide/application/service/dsi-report-service/interface';

/**
 * 切页耗时监听服务
 */
export class CcnrObserver implements ICcnrObserver {
    private slideChangeMap = new Map<number, {
        startTime: number,
        promise: Promise<number>,
        resolve: (param: number) => void
    }>();

    public constructor() {
        this.addSlideChangeListener();
    }

    public getSlideChangePromise(slideIndex: number): Promise<number> | undefined {
        return this.slideChangeMap.get(slideIndex)?.promise;
    }

    private addSlideChangeListener() {
        // 监听页的开始切换
        eventBus.on(EventKeys.SLIDE_CHANGE_INDEX_BEFORE, async (slideIndex) => {
            let newPromiseResolve;
            const newPromise: Promise<number> = new Promise((resolve) => {
                newPromiseResolve = resolve;
            });
            this.slideChangeMap.set(slideIndex, {
                startTime: Date.now(),
                promise: newPromise,
                resolve: newPromiseResolve,
            });
        });
        // 监听页的渲染完成
        eventBus.on(EventKeys.SLIDE_CHANGE_INDEX_AFTER, async (slideIndex) => {
            const item = this.slideChangeMap.get(slideIndex);
            if (item) {
                item.resolve(Date.now() - item.startTime);
            }
        });
    }
}
